export default __webpack_public_path__ + "static/media/02b6e2a7-787c-46cb-b5b3-2dfafb6d23e2.3192bf37.webp";